<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text, vue/no-root-v-if -->
<script setup>
import { computed } from 'vue';

const props = defineProps({
  min: { type: [Number, String], default: null },
  max: { type: [Number, String], default: null },
});

function format(value) {
  if (value == null || value === '') return null;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0,
  }).format(Number(value));
}

const formatted = computed(() => {
  const minVal = format(props.min);
  const maxVal = format(props.max);
  if (minVal && maxVal) return `${minVal} — ${maxVal}`;
  if (minVal) return `A partir de ${minVal}`;
  if (maxVal) return `Até ${maxVal}`;
  return null;
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text, vue/no-root-v-if -->
  <span
    v-show="formatted"
    class="rounded-full bg-lais-primary-50 px-3 py-1 text-[12px] font-semibold text-lais-primary"
  >
    {{ formatted }}
  </span>
</template>
